import React from 'react';

import {Stack, Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import {Carousel, ErrorState} from 'presentation/components';

import {CarrouselTypeEnum} from 'presentation/constants/carrouselTypeEnum';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {chunkArray} from 'presentation/utils/chunckArray';
import {useLifeplaceProductsQuery} from '../../../queries/useLifeplaceProductsQuery';
import {LifeplaceProductsLoading} from './Loading';
import {ProductCard} from './ProductCard';
import {getItemsPerSlide} from './utils/formatSlides';
import {StyledBox} from './styles';

const {title, error} = translations['pt-br'].privateFlow.perks.lifeplace.products;

export const LifeplaceProducts = () => {
	const {data: products, isLoading, isError, refetch} = useLifeplaceProductsQuery();
	const {isMobile, isTablet, betweenMobileAndDesktop} = useMediaQueries();

	if (isLoading) {
		return <LifeplaceProductsLoading />;
	}

	if (isError) {
		return (
			<Stack gap={2}>
				<Typography fontSize={20} fontWeight={600} color="text.primary">
					{title}
				</Typography>
				<ErrorState
					title={error.title}
					description={error.description}
					handleRefresh={refetch}
				/>
			</Stack>
		);
	}

	const hasProducts = products && products.length > 0;

	if (!hasProducts) return null;

	const itemsPerSlide = getItemsPerSlide(isMobile, betweenMobileAndDesktop);
	const productChunks = chunkArray(products, itemsPerSlide);

	return (
		<Stack gap={2}>
			<Typography fontSize={20} fontWeight={600} color="text.primary">
				{title}
			</Typography>

			<StyledBox>
				<Carousel
					type={CarrouselTypeEnum.DOTS}
					isFullscreen
					slides={productChunks.map((chunk, index) => (
						<Stack
							direction="row"
							gap={isTablet ? 1 : 3}
							key={`slide-${index}`}
							height="100%">
							{chunk.map(product => (
								<ProductCard key={product.name} {...product} />
							))}
						</Stack>
					))}
				/>
			</StyledBox>
		</Stack>
	);
};
